export const VIEW_STATE = {LOADING: 0, ERROR: -1, LOADED: 1}
export const MODAL_VIEW_STATE = {LOADING: 0, NOT_LOADING: 1}
export const HOME_ROW_TYPE = {COURSE: "course", BANNER: "banner"}
export const BAZAAR_LINK = "https://cafebazaar.ir/app/com.cafearabi.app"
export const CONTENT_TYPE = {
    COURSE:"course",
    CLASS:"class",
    PROFILE:"profile",
    LEITNER:"leitner",
    DICTIONARY:"dictionary",
    COURSE_CATEGORY:"courseCategory",
    URL:"url",
}
export const LESSON_TYPE = {
    VIDEO:"video",
    AUDIO:"audio",
    PDF:"pdf",
    PDF_AUDIO:"pdf_audio"
}
